export default __webpack_public_path__ + "static/media/51.c3fb1af5.jpeg";